/**
 * TrustBar — a horizontal band of trust badges shown right below the hero.
 *
 * Combines authority signals (certifications, brand partners, warranty) into
 * one glanceable strip. Static — edit values here to update.
 */
import { Shield, Award, Handshake, Building2, Zap, Trophy } from "lucide-react";

const BADGES = [
  { icon: Shield,     title: "3-ročná záruka",       sub: "na kvalitu prác" },
  { icon: Trophy,     title: "172+ projektov",        sub: "dokončených" },
  { icon: Award,      title: "4.9 ★ recenzie",        sub: "reálni klienti" },
  { icon: Handshake,  title: "Cena po podpise",       sub: "nemenná — garantované" },
  { icon: Building2,  title: "Baumit · Porotherm",    sub: "certifikovaní partneri" },
  { icon: Zap,        title: "Cenová ponuka do 24h",  sub: "bezplatne · nezáväzne" },
];

export default function TrustBar() {
  return (
    <section
      className="bg-gradient-to-b from-[#0a0a0a] to-[#0f0f0f] border-y border-white/5 py-8"
      aria-label="Prečo SuperMajstri"
      data-testid="trust-bar"
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-6">
          {BADGES.map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={i}
                className="flex items-center gap-3 group"
                data-testid={`trust-${i}`}
              >
                <div className="w-11 h-11 rounded-xl bg-[#00E5FF]/10 border border-[#00E5FF]/25 flex items-center justify-center flex-shrink-0 group-hover:bg-[#00E5FF]/20 group-hover:border-[#00E5FF]/50 transition-all">
                  <Icon size={18} className="text-[#00E5FF]" />
                </div>
                <div className="min-w-0">
                  <div className="text-[13px] font-bold text-white leading-tight truncate">
                    {b.title}
                  </div>
                  <div className="text-[11px] text-zinc-500 leading-tight truncate">
                    {b.sub}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
